module.exports = __webpack_public_path__ + "img/chapter-1-thumb.71d0484d.jpg";